import { HttpContextToken } from '@angular/common/http';

/**
 * When set to true on a request's HttpContext, the authInterceptor leaves a
 * 401/403 alone — no global clearSession() + redirect to start. Used by
 * SessionService.checkSession(): the session probe treats a 401 as a valid
 * "not logged in" answer and handles it itself, so the global handler (which
 * would strip the URL's query params on its redirect) must stay out of it.
 *
 * Lives in its own file so both the interceptor and SessionService can import
 * it without a circular dependency (the interceptor imports SessionService).
 */
export const SKIP_AUTH_REDIRECT = new HttpContextToken<boolean>((): boolean => false);
